import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  return <AnimatePresence data-id="element-46">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-47">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-gray-900 border border-gray-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-48">
            <div className="flex items-center justify-between p-6 border-b border-gray-700" data-id="element-49">
              <h2 className="text-xl font-bold text-white" data-id="element-50">{title}</h2>
              <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-1" data-id="element-51">
                <XIcon className="w-6 h-6" data-id="element-52" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-53">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="py-8 px-4 bg-black border-t border-gray-800" data-id="element-54">
        <div className="max-w-6xl mx-auto text-center text-gray-500 text-sm space-y-3" data-id="element-55">
          <div className="flex items-center justify-center gap-4" data-id="element-56">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-amber-400 transition-colors" data-id="element-57">
              Política de Privacidad
            </button>
            <span data-id="element-58">|</span>
            <button onClick={() => setShowTerms(true)} className="hover:text-amber-400 transition-colors" data-id="element-59">
              Términos y Condiciones
            </button>
          </div>
          <p data-id="element-60">
            © 2026 The AI Freelance Goldmine. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-61">
        <p className="text-amber-400 font-semibold" data-id="element-62">
          Última actualización: Enero 2026
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-63">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-64">
          Recopilamos información personal que nos proporcionas voluntariamente
          al realizar una compra o registrarte en nuestro sitio, incluyendo:
          nombre completo, dirección de correo electrónico, información de pago
          (procesada de forma segura por terceros) y dirección IP.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-65">
          2. Uso de la Información
        </h3>
        <p data-id="element-66">Utilizamos tu información para:</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-67">
          <li data-id="element-68">Procesar y entregar tu compra de productos digitales.</li>
          <li data-id="element-69">
            Enviarte actualizaciones importantes sobre tu cuenta y productos
            adquiridos.
          </li>
          <li data-id="element-70">Mejorar nuestros productos y servicios.</li>
          <li data-id="element-71">
            Comunicarnos contigo sobre ofertas y contenido relevante (puedes
            darte de baja en cualquier momento).
          </li>
        </ul>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-72">
          3. Protección de Datos
        </h3>
        <p data-id="element-73">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Utilizamos encriptación SSL
          para todas las transacciones.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-74">
          4. Compartir Información
        </h3>
        <p data-id="element-75">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          ayudan a operar nuestro sitio web y procesar pagos, siempre que dichas
          partes acuerden mantener esta información confidencial.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-76">5. Cookies</h3>
        <p data-id="element-77">
          Utilizamos cookies para mejorar tu experiencia en nuestro sitio,
          analizar el tráfico y personalizar el contenido. Puedes configurar tu
          navegador para rechazar cookies, aunque esto puede afectar la
          funcionalidad del sitio.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-78">6. Tus Derechos</h3>
        <p data-id="element-79">
          Tienes derecho a acceder, rectificar, eliminar o limitar el uso de tus
          datos personales. Para ejercer estos derechos, contáctanos a través de
          nuestro correo electrónico de soporte.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-80">7. Contacto</h3>
        <p data-id="element-81">
          Si tienes preguntas sobre esta política de privacidad, puedes
          contactarnos en:{' '}
          <span className="text-amber-400" data-id="element-82">
            soporte@aifreelancegoldmine.com
          </span>
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-83">
        <p className="text-amber-400 font-semibold" data-id="element-84">
          Última actualización: Enero 2026
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-85">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-86">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, aceptas estar sujeto a estos términos y condiciones. Si no
          estás de acuerdo con alguna parte de estos términos, no debes utilizar
          nuestro sitio ni adquirir nuestros productos.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-87">
          2. Productos Digitales
        </h3>
        <p data-id="element-88">
          "The AI Freelance Goldmine" es un producto digital educativo que
          incluye guías, plantillas y recursos. Los resultados pueden variar
          según el esfuerzo, dedicación y circunstancias individuales de cada
          usuario. No garantizamos ingresos específicos.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-89">
          3. Política de Reembolso
        </h3>
        <p data-id="element-90">
          Ofrecemos una garantía de satisfacción de 7 días. Si dentro de los
          primeros 7 días calendario desde tu compra no estás satisfecho con el
          producto, puedes solicitar un reembolso completo enviando un correo a
          nuestro equipo de soporte. El reembolso se procesará en un plazo de
          5-10 días hábiles.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-91">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-92">
          Todo el contenido incluido en nuestros productos digitales (textos,
          gráficos, plantillas, prompts y materiales) es propiedad exclusiva de
          The AI Freelance Goldmine. Queda prohibida la reproducción,
          distribución o reventa del material sin autorización expresa por
          escrito.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-93">
          5. Uso Permitido
        </h3>
        <p data-id="element-94">
          La licencia de compra es personal e intransferible. El comprador puede
          utilizar los materiales para su uso personal y profesional, pero no
          puede compartir, revender o distribuir el contenido a terceros.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-95">
          6. Limitación de Responsabilidad
        </h3>
        <p data-id="element-96">
          Los testimonios y ejemplos de ingresos mostrados en este sitio son
          resultados individuales y no constituyen una garantía de que obtendrás
          los mismos resultados. Tu éxito depende de múltiples factores
          incluyendo tu esfuerzo, habilidades y condiciones del mercado.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-97">
          7. Modificaciones
        </h3>
        <p data-id="element-98">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación en el sitio web. Es tu responsabilidad revisar
          periódicamente estos términos.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-99">
          8. Ley Aplicable
        </h3>
        <p data-id="element-100">
          Estos términos se rigen por las leyes de los Estados Unidos de
          América. Cualquier disputa será resuelta en los tribunales competentes
          del estado donde opera la empresa.
        </p>

        <h3 className="text-white font-bold text-base mt-4" data-id="element-101">9. Contacto</h3>
        <p data-id="element-102">
          Para cualquier consulta sobre estos términos, contáctanos en:{' '}
          <span className="text-amber-400" data-id="element-103">
            soporte@aifreelancegoldmine.com
          </span>
        </p>
      </Modal>
    </>;
}